export default "__VITE_ASSET__C7Lxt0CB__"